export default "__VITE_ASSET__BwV9B44x__"